import { render, staticRenderFns } from "./TrainTicketQuery.vue?vue&type=template&id=83724d38&scoped=true&"
import script from "./TrainTicketQuery.vue?vue&type=script&lang=js&"
export * from "./TrainTicketQuery.vue?vue&type=script&lang=js&"
import style0 from "./TrainTicketQuery.vue?vue&type=style&index=0&id=83724d38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83724d38",
  null
  
)

export default component.exports